import { render } from "./ContentPageColumn.vue?vue&type=template&id=c559c192&scoped=true&ts=true"
import script from "./ContentPageColumn.vue?vue&type=script&lang=ts"
export * from "./ContentPageColumn.vue?vue&type=script&lang=ts"

import "./ContentPageColumn.vue?vue&type=style&index=0&id=c559c192&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c559c192"]])

export default __exports__